import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterMedia({ editMode, media, onRegisterMedia }: { editMode: string; media?: Types.MediaDto; onRegisterMedia?: () => void }) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [mediaId, setMediaId] = useState("");
    const [mediaTitle, setMediaTitle] = useState("");
    const [mediaUrl, setMediaUrl] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [mediaCopyright, setMediaCopyright] = useState("");
    const [mediaWriter, setMediaWriter] = useState("");

    const requestAxiosAddMedia = async (data: Types.MediaDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.MEDIA_URL, data);

        return response.data;
    };

    const { loading: loadingAddMedia, error: errorAddMedia, data: resultAddMedia, execute: requestAddMedia } = useAsyncAxios(requestAxiosAddMedia);

    useEffect(() => {
        if (media === undefined) return;

        form.setFieldsValue(media);
    }, [media]);

    useEffect(() => {
        if (resultAddMedia === null) return;

        if (onRegisterMedia) onRegisterMedia();

        alert.setAlert(AlertType.SUCCESS, "미디어 추가 성공", "미디어 추가를 완료하였습니다.");
    }, [resultAddMedia]);

    useEffect(() => {
        if (errorAddMedia === null) return;

        console.log("errorMedia", errorAddMedia);
        alert.setAlert(errorAddMedia.response.data.code, "미디어 추가 실패", errorAddMedia.response.data.message);
    }, [errorAddMedia]);

    const requestAxiosUpdateMedia = async (data: Types.MediaDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().put(Request.MEDIA_URL + "/" + data.mediaId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateMedia,
        error: errorUpdateMedia,
        data: resultUpdateMedia,
        execute: requestUpdateMedia,
    } = useAsyncAxios(requestAxiosUpdateMedia);

    useEffect(() => {
        if (resultUpdateMedia === null) return;

        if (onRegisterMedia) onRegisterMedia();

        alert.setAlert(AlertType.SUCCESS, "미디어 수정 성공", "미디어 수정을 완료하였습니다.");
    }, [resultUpdateMedia]);

    useEffect(() => {
        if (errorUpdateMedia === null) return;

        console.log("errorUpdateMedia", errorUpdateMedia);
        alert.setAlert(errorUpdateMedia.response.data.code, "미디어 수정 실패", errorUpdateMedia.response.data.message);
    }, [errorUpdateMedia]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const data: Types.MediaDto = {
            ...values,
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddMedia(data);
        else if (editMode === "update") requestUpdateMedia(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="mediaId" label="미디어 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="mediaTitle"
                                label="미디어 이름"
                                rules={[
                                    {
                                        required: true,
                                        message: "미디어 제목을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="미디어 제목을 입력해 주세요." onChange={(e) => setMediaTitle(e.target.value)} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="mediaUrl"
                                label="미디어 URL"
                                rules={[
                                    {
                                        required: true,
                                        message: "미디어 URL을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="미디어 URL을 입력해 주세요." onChange={(e) => setMediaUrl(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="imageUrl" label="이미지 URL">
                                <Input placeholder="이미지 URL을 입력해 주세요." onChange={(e) => setImageUrl(e.target.value)} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="mediaCopyright"
                                label="미디어 출처"
                                rules={[
                                    {
                                        required: true,
                                        message: "미디어 출처를 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="미디어 출처를 입력해 주세요." onChange={(e) => setMediaCopyright(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="mediaWriter"
                                label="미디어 글쓴이"
                                rules={[
                                    {
                                        required: true,
                                        message: "미디어 글쓴이를 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="미디어 글쓴이를 입력해 주세요." onChange={(e) => setMediaWriter(e.target.value)} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterMedia;
